import React from 'react'

const withEventHandlers = WrappedComponent => {
  return props => {
    const {
      form, // via useState
      setForm, // via useState
      updatePreferences // via mutation
    } = props

    // update state when toggling checkbox for a preference with "name"
    const handleToggleCheckbox = name => event => {
      setForm({ ...form, [name]: String(event.target.checked) })
    }

    // update state when changing radio button (e.g. reup)
    const handleChangeFormField = name => event =>
      setForm({ ...form, [name]: event.target.value })

    // perform GraphQL mutation
    const handleClickUpdate = e => {
      e.preventDefault()
      updatePreferences({
        variables: {
          input: {
            onlineOnly: form.onlineOnly === 'true',
            newProjectNotifications: form.newProjectNotifications === 'true'
          }
        }
      })
    }

    return (
      <WrappedComponent
        onToggleCheckbox={handleToggleCheckbox}
        onClickUpdate={handleClickUpdate}
        onChangeFormField={handleChangeFormField}
        {...props}
      />
    )
  }
}

export default withEventHandlers
